import { Backdrop, Box, Button } from "@mui/material";
import { CircularProgress, TextField } from "@mui/material";
import { FormControlLabel, Modal, Switch } from "@mui/material";
import { RegisterUserRequest } from "../../proto/api_pb";
import { styles } from "../../pages/AdminControls/styles";
import { useEffect, useState } from "react";
import { OmmuseClient } from "../../proto/api_grpc_web_pb";
import { toast } from "react-toastify";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { useGetAllUsers } from "../../hooks/useGetAllUsers";
import { ModalProp } from "./types";

export const EditProfileModal: React.FC<ModalProp> = ({
  isModalOpen,
  selectedUser,
  handleModal,
}) => {
  const [error, setError] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>("");
  const [isFieldEmpty, setIsFieldEmpty] = useState<boolean>(false);
  const [isMintingAllowed, setIsMintingAllowed] = useState<boolean>(
    selectedUser.getApproved()
  );
  const { getAllUsers } = useGetAllUsers();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { getValidAccessToken } = useGetValidAccessToken();
  const validate = /^[A-Za-z\s]*$/;
  const handleUserNameChange = (name: string) => {
    setError(false);
    setIsFieldEmpty(false);
    if (!validate.test(name)) {
      setError(true);
      setUserName(name);
    } else {
      setUserName(name);
    }
  };

  const handleMintApproval = () => {
    setIsMintingAllowed(!isMintingAllowed);
  };

  const handleSubmit = async (): Promise<void> => {
    setIsLoading(true);
    if (userName && !isFieldEmpty && !error) {
      const accessToken = await getValidAccessToken();
      const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
      const request = new RegisterUserRequest();
      request.setUserId(selectedUser.getUserId());
      request.setFirstName(selectedUser.getFirstName());
      request.setLastName(selectedUser.getLastName());
      request.setUsername(userName);
      request.setEmail(selectedUser.getEmail());
      request.setGenresList(selectedUser.getGenresList());
      request.addWalletAddresses(selectedUser?.getWalletAddressesList()[0]);
      request.setSkillsList(selectedUser.getSkillsList());
      request.setBio(selectedUser.getBio());
      request.setApproved(isMintingAllowed);
      const metadata = {
        Authorization: `${accessToken}`,
        "Access-Control-Allow-Origin": "*",
      };

      ommuseClient.registerUser(request, metadata, function (err, response) {
        if (err) {
          setIsLoading(false);
          console.log("register user error", err);
          alert(err);
        } else {
          handleModal(selectedUser);
          toast.success("Changes saved");
          console.log("Saved Changes");
          getAllUsers();
          setIsLoading(false);
        }
      });
    } else {
      setIsLoading(false);
      setIsFieldEmpty(true);
    }
  };

  useEffect(() => {
    setUserName(selectedUser.getUsername());
    setIsMintingAllowed(selectedUser.getApproved());
  }, [selectedUser]);

  return (
    <>
      <Backdrop
        open={isLoading}
        invisible={false}
        sx={{ color: "#fff", zIndex: 10 }}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      <Modal sx={{ zIndex: 1 }} open={isModalOpen}>
        <Box sx={styles.modalContainerStyles}>
          <div>
            <h4>Edit Profile</h4>
            <Box sx={{ marginBottom: "20px" }}>
              <TextField
                value={userName}
                error={error || isFieldEmpty}
                id="outlined-error-helper-text"
                label="Enter new username"
                onChange={(e) => handleUserNameChange(e.target.value)}
                sx={{ margin: "5px" }}
              />
              <br />
              {isFieldEmpty && (
                <span style={{ color: "red" }}>Field should not be empty</span>
              )}
              {error && (
                <span style={{ color: "red" }}>
                  Special characters & numbers are not allowed
                </span>
              )}
            </Box>
            <FormControlLabel
              value="top"
              control={
                <Switch
                  disabled={isMintingAllowed}
                  checked={isMintingAllowed}
                  color="primary"
                />
              }
              label="Allow for Minting"
              labelPlacement="top"
              onChange={handleMintApproval}
            />
            <br />
            <Button
              onClick={handleSubmit}
              sx={styles.button}
              variant="contained"
            >
              Save
            </Button>
            <Button
              onClick={() => handleModal(selectedUser)}
              sx={styles.button}
              variant="contained"
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};
